function home() {
    $(document).ready(function () {
        $('.s-logos-slider').slick({
            infinite: true,
            slidesToShow: 6,
            slidesToScroll: 1,
            autoplay: false,
            autoplaySpeed: 2000,
            arrows: false,
            dots: false,
            responsive: [
                {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 1,
                        infinite: true,
                        dots: false
                    }
                },
                {
                    breakpoint: 600,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 1
                    }
                },
                {
                    breakpoint: 480,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 1
                    }
                }
            ]
        });

        /**
         *
         */
        $('.b-counter').each(function (index, element) {
            let date = $(element).attr('data-time');
            let dateFormatted = moment(date).add(9, 'hours');
            let counter = $(this);

            $(element).countdown(dateFormatted.format('YYYY/MM/D H:m:s'), function (event) {
                counter.find('.b-counter-days .e-value').html(event.strftime('%D'));

                if (event.strftime('%D') == 1) {
                    counter.find('.b-counter-days .e-label').html('day');
                }

                counter.find('.b-counter-hours .e-value').html(event.strftime('%H'));

                if (event.strftime('%H') == 1) {
                    counter.find('.b-counter-hours .e-label').html('hour');
                }

                counter.find('.b-counter-min .e-value').html(event.strftime('%M'));
                counter.find('.b-counter-sec .e-value').html(event.strftime('%S'));
            });
        });

        /**
         *
         */
        $('.slider-variable').slick('unslick');
        $('.slider-variable').slick({
            centerMode: true,
            centerPadding: '0',
            slidesToShow: 3,
            focusOnSelect: true,
            responsive: [
                {
                    breakpoint: 768,
                    settings: {
                        arrows: false,
                        centerMode: true,
                        centerPadding: '40px',
                        slidesToShow: 3
                    }
                },
                {
                    breakpoint: 480,
                    settings: {
                        arrows: false,
                        centerMode: true,
                        centerPadding: '40px',
                        slidesToShow: 1
                    }
                }
            ]
        });
        $('.slider-variable').slick('slickGoTo', 1);

        $('.slider-variable .slick-slide:nth-child(1)').addClass('is-visible')
        $('.slider-variable .slick-slide:nth-child(2)').addClass('is-visible')
        $('.slider-variable .slick-slide:nth-child(3)').addClass('is-visible')

        $('.slider-variable').on('beforeChange', function (event, slick, currentSlide, nextSlide) {
            $('.slider-variable .slick-slide').removeClass('is-visible')
            $('.slider-variable .slick-slide:nth-child(' + nextSlide + ')').addClass('is-visible')
            $('.slider-variable .slick-slide:nth-child(' + (nextSlide + 1) + ')').addClass('is-visible')
            $('.slider-variable .slick-slide:nth-child(' + (nextSlide + 2) + ')').addClass('is-visible')
            // console.log(nextSlide);
        });
    });

    /**
     *
     */
    var lastId,
        topMenu = $(".site-header .main-navigation"),
        topMenuHeight = topMenu.outerHeight() + 15,
        // All list items
        menuItems = topMenu.find("a"),
        // Anchors corresponding to menu items
        scrollItems = menuItems.map(function () {
            if ($(this).attr("href").indexOf('#') === -1) {
                return null;
            }

            var item = $($(this).attr("href"));

            if (item.length) {
                return item;
            }
        });

    $(window).scroll(function () {

        if (scrollItems.length === 0) {
            return null;
        }

        // Get container scroll position
        var fromTop = $(this).scrollTop() + topMenuHeight + 100;

        // Get id of current scroll item
        var cur = scrollItems.map(function () {
            if ($(this).offset().top < fromTop)
                return this;
        });
        // Get the id of the current element
        cur = cur[cur.length - 1];
        var id = cur && cur.length ? cur[0].id : "";

        if (lastId !== id) {
            lastId = id;
            // Set/remove active class
            menuItems
                .parent().removeClass("current-menu-item")
                .end().filter("[href='#" + id + "']").parent().addClass("current-menu-item");
        }
    });

    /**
     *
     */
    $('.b-participations .btn').click(function (e) {
        e.preventDefault();
        let participation_tag = $(this).attr("href");
        let participation = participation_tag.replace('#', '');

        $('select[name="your-participation"]').val(participation).trigger("chosen:updated");

        $('html, body').animate({
            scrollTop: $('#register').offset().top - 100
        }, 100);
    });

    /**
     *
     */
    $('.b-sponsorships .wp-block-button__link').click(function (e) {
        e.preventDefault();

        $('select[name="your-participation"]').val('panelist').trigger("chosen:updated");

        $('html, body').animate({
            scrollTop: $('#register').offset().top - 100
        }, 100);
    });

    /**
     * intro video
     */
    $(document).ready(function (e) {
        $('.intro-video').on('play', function (e) {
            $('.video-intro .wp-block-cover__image-background').fadeOut();
        });

        $('.leaflet-marker-icon').click()

        AOS.init({
            once: true, // whether animation should happen only once - while scrolling down
        });
    });


    /**
     * Animations
     */

    let animationOffset = '100';
    let animationDuration = '1500';

    $('.wp-container-3 .b-post-single:nth-child(1)')
        .attr('data-aos', 'fade-in')
        .attr('data-aos-duration', animationDuration)
        .attr('data-aos-delay', '100')

    $('.wp-container-3 .b-post-single:nth-child(2)')
        .attr('data-aos', 'fade-in')
        .attr('data-aos-duration', animationDuration)
        .attr('data-aos-delay', '400')

    $('.wp-container-3 .b-post-single:nth-child(3)')
        .attr('data-aos', 'fade-in')
        .attr('data-aos-duration', animationDuration)
        .attr('data-aos-delay', '700')

    $('.wp-block-cb-carousel')
        .attr('data-aos', 'fade-in')
        .attr('data-aos-duration', animationDuration)
}

export {home};
